import Backend from 'backend';
import {customElement, bindable} from 'aurelia-framework';
import {inject, TaskQueue} from 'aurelia-framework';

@customElement('excise-report-content-component')
@inject(Backend, Element, TaskQueue)
export class ExciseReportContentComponent {
  backend;
  element;
  taskQueue;

  @bindable()
  report;

  constructor(backend, element, taskQueue) {
    this.backend = backend;
    this.element = element;
    this.taskQueue = taskQueue;
  }
}
